import type { ExportStatusResponse } from '../models/export';

const POLL_INTERVAL_MS = 2500;

export async function waitForExport(
  poll: (exportId: string) => Promise<ExportStatusResponse>,
  exportId: string,
  options?: {
    intervalMs?: number;
    isCancelled?: () => boolean;
    onStatusChange?: (status: ExportStatusResponse['status']) => void;
  },
): Promise<string> {
  const intervalMs = options?.intervalMs ?? POLL_INTERVAL_MS;

  for (;;) {
    if (options?.isCancelled?.()) {
      throw new Error('EXPORT_CANCELLED');
    }

    const { status, url_file, error } = await poll(exportId);
    options?.onStatusChange?.(status);

    if (status === 'completed' && url_file) {
      return url_file;
    }

    if (status === 'failed') {
      throw new Error(error ?? 'Export fallido');
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }
}
